import Vue from "vue";
import BaiduMap from "vue-baidu-map";
// npm install vue-baidu-map --save
Vue.use(BaiduMap, {
  ak: "l2DCwygcvuiklzVdHdA33nAQ1XeycuuR"
});
